module.exports = __webpack_public_path__ + "img/trabajar-desde-casa.cd38a654.png";